export default {"src":"/_next/static/media/cold-plunge.2b98c31f.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};